/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("FrontCallService.modules.table", ["FrontCallService"], function (context, cls) {
  /**
   * Tables module to handle Table frontcalls
   * @instance table
   * @memberOf gbc.FrontCallService.modules
   */
  context.FrontCallService.modules.table = /** @lends gbc.FrontCallService.modules.table */ {
    /**
     * Frontcall equivalent to right click table column header -> autofitAllColumns
     * @param {screenRecord} name of the table to autofit
     */
    autofitAllColumns: function (screenRecord) {
      if (!screenRecord || screenRecord.length === 0) {
        this.parametersError("autofitAllColumns frontcall: Screen record not provided");
        return;
      }
      const app = gbc.SessionService.getCurrent().getCurrentApplication();
      app.scheduler.callbackCommand(() => {
        const allWidgets = gbc.WidgetService.getAllWidgets().filter((widget) => {
          return widget.getTabName?.() === screenRecord;
        });
        if (allWidgets.length > 1) {
          console.error("autofitAllColumns frontcall: Screen record is associated to more than one element");
          return;
        }
        const targetWidget = allWidgets.pop();
        if (!targetWidget?.autofitAllColumns) {
          console.error("autofitAllColumns frontcall: Invalid screen record");
          return;
        }
        targetWidget.autofitAllColumns();
      });
      return [];
    },

    /**
     * Frontcall equivalent to right click table column header -> fitToViewAllColumns
     * @param {screenRecord} name of the table to fit to view
     */
    fitToViewAllColumns: function (screenRecord) {
      if (!screenRecord || screenRecord.length === 0) {
        this.parametersError("fitToViewAllColumns frontcall: Screen record not provided");
        return;
      }
      const app = gbc.SessionService.getCurrent().getCurrentApplication();
      app.scheduler.callbackCommand(() => {
        app.layout.refreshLayout();
        const allWidgets = gbc.WidgetService.getAllWidgets().filter((widget) => {
          return widget.getTabName?.() === screenRecord;
        });

        if (allWidgets.length > 1) {
          console.error("fitToViewAllColumns frontcall: Screen record associated to more than one element");
          return;
        }
        const targetWidget = allWidgets.pop();
        if (!targetWidget?.fitToViewAllColumns) {
          console.error("fitToViewAllColumns frontcall: Invalid screen record");
          return;
        }
        targetWidget.fitToViewAllColumns();
      });
      return [];
    }
  };
});
